import { render, staticRenderFns } from "./ReportDownload.vue?vue&type=template&id=9560467e&"
import script from "./ReportDownload.vue?vue&type=script&lang=js&"
export * from "./ReportDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports